<template>
    <div>
        <q-score-card key="QScoreCardPlaced" title="Placed" api-endpoint="placed" drill-down-label="Policy Breakdown" :drill-down-route="drillDownRoute ? drillDownRoute : 'Placed Policies'" card-style="production" :agent-code="agentCode" :filters="filters" :default-goal="defaultGoal" format="Currency" :show-drill-down-on-personal="true">
            Note: Policies that have been bound and premium paid at the carrier - updated monthly on the 10th.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardPlaced",
    props: ["agentCode", "filters", "defaultGoal", "drillDownRoute"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
